import { EditorThemeClasses } from 'lexical';

export const theme: EditorThemeClasses = {
  hr: 'MarkdownEditorTheme__hr',
  hrSelected: 'MarkdownEditorTheme__hrSelected',
  mark: 'MarkdownEditorTheme__mark',
  text: {
    underline: 'MarkdownEditorTheme__text-underline',
    strikethrough: 'MarkdownEditorTheme__text-strikethrough',
  },
  list: {
    nested: {
      listitem: 'MarkdownEditorTheme__nested-list-item',
    },
  },
  table: 'MarkdownEditorTheme__table',
  tableRow: 'MarkdownEditorTheme__tableRow',
  tableCell: 'MarkdownEditorTheme__tableCell',
  tableCellHeader: 'MarkdownEditorTheme__tableCellHeader',
};
